// extracted by mini-css-extract-plugin
export var smallSpinner = "_wn-0";